module.exports = __webpack_public_path__ + "static/img/4.c9bd1e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/4.png
// module id = rxzZ
// module chunks = 0